import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import classNames from 'classnames';
import VerifiedTradePromoInfo from './VerifiedTradePromoInfo';
import { applyPromo, promoCoversShipping } from './verifiedTradePromoHelpers.es';
import { ViewerFragment } from './verifiedTradePromoFragments.es';
import { shipping } from './verifiedTradePromoConstants.es';
import style from './VerifiedTradePromo.scss';

const _getShippingPromoString = shippingAmount => {
    const { texts } = shipping;
    return promoCoversShipping(shippingAmount) ? texts.FREE_SHIPPING : texts.CREDIT_APPLIED;
};

const VerifiedTradePromo = props => {
    const { viewer, inShippingModal, shippingAmount } = props;
    const { texts } = shipping;

    return applyPromo(viewer) ? (
        <div className={classNames(style.promoContainer, {[style.inShippingModal]: inShippingModal})}>
            <div className={style.textContainer}>
                <span className={style.highlightedText}>
                    {inShippingModal ? _getShippingPromoString(shippingAmount) : texts.FREE_SHIPPING}
                </span>
                {!inShippingModal && texts.FIRST_ORDER}
            </div>
            <VerifiedTradePromoInfo tooltipDirection={inShippingModal ? 'left' : 'top'} />
        </div>
    ) : null;
};

VerifiedTradePromo.propTypes = {
    viewer: PropTypes.object,
    inShippingModal: PropTypes.bool,
    shippingAmount: PropTypes.object
};

export default Relay.createContainer(VerifiedTradePromo, {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        viewer: () => Relay.QL`
            fragment on Viewer {
                ${ViewerFragment}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/VerifiedTradePromo.jsx